import { runtimeStageAssetIdBySceneId } from "./assets";
import type { ContentBlock, Source } from "./schema";

export const sources = [
  {
    id: "SRC_TEXTBOOK_CH3",
    title: "《中国共产党简史》第三章《全民族抗日战争的中流砥柱》",
    organization: "人民出版社、中共党史出版社",
    provenanceType: "textbook",
    reviewState: "approved",
    note: "本项目核心教材；运行时统一使用书内印刷页与源PDF页双页码。",
  },
  {
    id: "SRC_OWNER_C03",
    title: "统一战线总结段",
    organization: "项目确认增补文案",
    provenanceType: "owner_confirmed",
    reviewState: "pending_review",
    note: "已确认必须完整呈现；未核定前不得标作教材原文。",
  },
  {
    id: "SRC_GX_STUDENT_ARMY",
    title: "广西学生军团结抗战的精神传承与时代价值",
    organization: "广西日报 / 广西壮族自治区档案馆",
    url: "https://v.gxnews.com.cn/a/21840729",
    provenanceType: "local_extension",
    reviewState: "pending_review",
    note: "第三届广西学生军解散月份已按专家确认稿冻结；纸质审签原件由项目负责人保管，数字归档待映射。",
  },
  {
    id: "SRC_XI_YOUTH_QUOTE",
    title: "党的十九大报告相关青年论述",
    organization: "中华人民共和国教育部",
    url: "https://www.moe.gov.cn/jyb_xwfb/xw_zt/moe_357/jyzt_2017nztzl/2017_zt13/17zt13_zyjs/201710/t20171031_317898.html",
    provenanceType: "local_extension",
    reviewState: "pending_review",
  },
  {
    id: "SRC_GX_PARTY_HISTORY_2020",
    title: "旗帜不倒 抗战到底——中共广西地方组织在抗日战争中的历史贡献",
    organization: "中共广西区委党史研究室 / 广西日报",
    url: "https://epaper.gxrb.com.cn/gxrb2/html/2020-08/18/content_1708918.htm",
    provenanceType: "local_extension",
    reviewState: "pending_review",
  },
  {
    id: "SRC_GX_WAR_HISTORY",
    title: "广西与抗日战争",
    organization: "中国人民政治协商会议广西壮族自治区委员会",
    url: "https://www.gxzx.gov.cn/index.php?a=show&c=index&catid=115&id=25299&m=content",
    provenanceType: "local_extension",
    reviewState: "pending_review",
  },
  {
    id: "SRC_GUILIN_CITY_HISTORY",
    title: "桂林市——具有光荣斗争历史的城邑",
    organization: "中国人民政治协商会议广西壮族自治区委员会",
    url: "https://www.gxzx.gov.cn/index.php?a=show&c=index&catid=115&id=366&m=content",
    provenanceType: "local_extension",
    reviewState: "pending_review",
  },
] satisfies Source[];

export const frozenText = {
  m1s1Lecture:
    '1937年7月7日夜，日本侵略军悍然发动卢沟桥事变（七七事变），当地中国驻军奋起抵抗，全民族抗战由此爆发。卢沟桥事变发生的第二天，中共中央向全国发出通电："平津危急！华北危急！中华民族危急！只有全民族实行抗战，才是我们的出路！"\n\n在这生死存亡关头，只有全民族团结抗战才是生存和发展的唯一出路。中国共产党高举起抗日的大旗。同日，毛泽东、朱德、彭德怀等红军领导人致电蒋介石，表示红军将士愿意"为国效命，与敌周旋，以达保土卫国之目的"。\n\n为促进国共两党实现团结合作抗日，党中央派周恩来等将《中共中央为公布国共合作宣言》交给蒋介石。9月22日，国民党中央通讯社发表中共中央的宣言；23日，蒋介石发表实际上承认共产党合法地位的谈话。中共中央的宣言和蒋介石谈话的发表，宣告国共两党重新合作和抗日民族统一战线形成。\n\n8月，中共中央革命军事委员会发布命令，宣布红军改名为国民革命军第八路军（简称"八路军"），下辖三个师，全军约4.6万人。朱德任总指挥，彭德怀任副总指挥。9月，陕甘宁根据地改称陕甘宁边区，仍是党中央所在地。接着，党在南方八省的红军游击队改编为国民革命军陆军新编第四军（简称"新四军"），叶挺任军长，项英任副军长，全军约1.03万人。',
  c03: "团结就是力量，团结方能胜利。正是抗日民族统一战线这面旗帜，召唤着全中国的各党各派各界各军，召唤着全中国的工农兵学商，召唤着海内外的华夏儿女，众志成城，同仇敌忾，筑起了中华民族抗击日本侵略者的钢铁长城。",
  gx01Original:
    "抗日民族统一战线的旗帜，也召唤着广西各族人民。1937年全面抗战爆发后，广西各界迅速响应，桂林随即成为抗战文化重镇。在党的抗日民族统一战线政策感召下，广西学生军、广西战时工作团等组织相继成立，各族青年踊跃投身抗日救亡运动。",
  gx01C0401:
    "广西学生军是1936年至1941年间，由国民党广西当局组建、中共地下党组织参与领导的青年抗日军事化团体，是抗日民族统一战线的一支重要队伍。",
  gx01C0402:
    "广西学生军先后组建三届，其中第二、第三届影响力较大。在日军发动侵华战争后，中国共产党推动建立了以国共合作为基础的抗日民族统一战线。在中国共产党的倡导和全国抗日救国浪潮的推动影响下，1937年10月，广西当局招收近300人的青年学生，组建第二届学生军。12月，学生军从桂林出发北上抗日，转战鄂、豫、皖、苏等敌后广大地区，为抗日救国而奋斗。",
  gx01C0403:
    "1938年10月，日军占领广州、武汉后，广西告急。为了抵御日军入侵，同年11月，广西当局招收大中学生4200多人，组建第三届广西学生军。至1941年8月解散，第三届学生军足迹遍布广西、广东的65个县，广泛开展抗日救亡运动。",
  gx01C0404:
    "以青年担当肩负复兴使命。广西学生军生动诠释了何为“天下兴亡、匹夫有责”，他们的精神如同火炬，照亮着当代青年投身民族复兴伟业的前行之路。正如习近平总书记所言:“青年一代有理想、有本领、有担当，国家就有前途，民族就有希望。”",
  m4s2C05:
    "大生产运动是克服抗日根据地困难的重要一环，总方针是“发展经济，保障供给”。1939年2月，当困难刚刚露头的时候，毛泽东就发出了“自己动手”的号召。1941年，党中央再次强调必须走生产自救的道路。同年春，八路军第三五九旅开进南泥湾实行军垦屯田。他们发扬自力更生、奋发图强的精神，使昔日荒凉的南泥湾变成了“陕北的好江南”。\n\n在大生产运动中，中央领导人以身作则，起带头作用。毛泽东开垦了一块地，种上了菜；朱德组织了一个生产小组，开垦菜地三亩；1943年，中央直属机关等举行纺线比赛，任弼时夺得第一名，周恩来被评为纺线能手。1944年9月，中央警备团战士张思德，在大生产中因炭窑崩塌而牺牲。毛泽东在张思德追悼会上发表《为人民服务》的讲演，指出：“我们这个队伍完全是为着解放人民的，是彻底地为人民的利益工作的。”“我们为人民而死，就是死得其所。”\n\n各抗日根据地相继实行了精兵简政、统一领导、拥政爱民、“三三制”、减租减息等十大政策，对克服困难、渡过难关、巩固抗日根据地起了重要作用。\n\n各抗日根据地尤其是陕甘宁边区的共产党人，通过领导人民进行对敌斗争和根据地建设经验的积累，形成了带有体系性的观念和作风。延安精神就是这些观念和作风的集中表现，其主要内容是：坚定正确的政治方向，解放思想、实事求是的思想路线，全心全意为人民服务的根本宗旨，自力更生、艰苦奋斗的创业精神。延安精神培育了一代代中国共产党人，是我们党的宝贵精神财富。",
  gx02C06:
    "1938年10月后，从沦陷区辗转来桂林从事抗日文化活动的文化人士达1000多人。在中国共产党领导下，桂林抗战文化运动蓬勃发展起来，成为国统区抗战文化的一面旗帜，保证了桂林抗战文化的先进方向。1941年1月，皖南事变发生，广西政治形势进一步恶化。桂林八办被迫撤销，桂林抗日文化运动陷入低谷。中共南方工作委员会重建省工委；中共中央南方局组建中共桂林统战工作委员会。中共广西地方组织广泛开展抗日救亡活动，推动桂系当局成功举办西南剧展，再次掀起文化抗日救亡运动高潮。1944年冬，日军侵占桂林后，百余位抗日民主人士被疏散到昭平县黄姚一带。省工委选派一批党员到黄姚，协助创办《广西日报》（昭平版），使之成为桂东团结抗战的喉舌。中共桂林统战工作委员会坚定实行“荫蔽精干，长期埋伏，积蓄力量，以待时机”的方针，继续坚持联桂抗日，依靠李济深、李任仁等抗日民主派，领导和团结各界爱国文化人士，创办《文艺生活》等文艺刊物，顽强坚守桂林抗日救亡文化阵地，利用各种渠道宣传中共中央“发展进步势力，争取中间势力，孤立顽固势力”的抗战总方针，充分显示了坚强的战斗力量。\n\n抗战期间，桂林曾形成为我国抗战后方的文化中心，有“文化城”之称。大批文化名人和著名学者从全国各地云集桂林，从事各种文化和学术活动，开展抗日宣传，使桂林的文化事业空前繁荣。这当中，中国共产党做了许多工作。桂林“文化城”的形成，不仅促进了我国文化事业的发展，而且对当时广西和全国的抗战都起着极大的推动作用。",
  gx05C08:
    "中共中央曾在桂林设立八路军办事处，广西起到了我国抗战战略大后方和抗战基地的作用。八路军桂林办事处在桂系当局同意和支持下，于1938年11月成立，至1941年1月皖南事变，桂系追随蒋介石反共而被迫撤消，共存在了两年多时间。这期间，办事处做了大量的抗日救亡工作。主要有：开展统战活动，发展和巩固抗日民族统一战线；开展抗日宣传，领导抗日救亡运动；向革命圣地延安和八路军、新四军抗日前线输送物资和人才；担负党中央与南方各省党组织的联系等工作。这些工作为全国抗战的胜利作出了重大贡献。这是中国共产党对抗战的贡献，也是广西对抗战的贡献。",
  gx05C07:
    "1939年11月，日军第一次入侵广西，中共地方组织领导钦廉地区抗日武装斗争，组建邕宁八尺区游击队、中越边境抗日游击队。1944年夏，在获知日军为了打通大陆交通线、即将再次入侵广西的消息后，中共广西省工委虽然面临着“四无”（无武装、无枪支、无经费、基本上无搞过武装斗争的干部）严重困难，但依然坚定贯彻中共中央南方局关于放手发动群众、组织抗日武装、建立抗日游击根据地的指示精神，利用桂系提出的“坚壁清野”“焦土抗战”等口号，发动群众组织各种形式的抗日武装。通过共产党员的模范作用和耐心细致的思想工作，教育、改造这些队伍，使之成为由中国共产党掌握的人民武装或坚持抗日的爱国武装。1944年9月，日军再次入侵广西，广西各地党组织坚决执行省工委作出的《八月决定》，创建桂东北人民抗日游击纵队临（桂）阳（朔）联队近30支抗日游击武装，发动敌后20多个县的游击斗争，歼灭日、伪军1000多人。1945年初，黄彰、阮明等分别领导发动桂东南和钦廉四属抗日反顽起义，展现了共产党人坚决抗日救国的顽强意志和坚强决心。当时，侵桂日军发出“广西不能立足”哀叹。",
} as const;

export const contentBlocks = [
  {
    id: "M1S1_LECTURE",
    sceneId: "M1S1",
    order: 10,
    kind: "lecture",
    title: "从卢沟桥事变到统一战线形成",
    bodyZh: frozenText.m1s1Lecture,
    required: true,
    provenanceType: "textbook",
    sourceRefs: ["SRC_TEXTBOOK_CH3"],
    assetRefs: ["AST-M1S1-PROC-001", "AST-M1S1-PROC-002", "AST-M1S1-PROC-003", "AST-M1S1-PROC-004"],
    pageRefs: [{ print: "73—74", pdf: "93—94" }],
    reviewState: "pending_review",
  },
  {
    id: "M1S1_C03",
    sceneId: "M1S1",
    order: 20,
    kind: "summary",
    title: "团结就是力量",
    bodyZh: frozenText.c03,
    required: true,
    provenanceType: "owner_confirmed",
    sourceRefs: ["SRC_OWNER_C03"],
    assetRefs: ["AST-M1S1-PROC-005"],
    pageRefs: [],
    reviewState: "pending_review",
  },
  {
    id: "GX01_ORIGINAL",
    sceneId: "M1S1",
    order: 30,
    kind: "local_extension",
    title: "广西融入①｜各族人民响应统一战线",
    bodyZh: frozenText.gx01Original,
    required: true,
    provenanceType: "local_extension",
    sourceRefs: ["SRC_GX_STUDENT_ARMY"],
    assetRefs: ["AST-M1S1-PROC-006"],
    pageRefs: [],
    reviewState: "pending_review",
    visibleLabel: "拓展材料",
  },
  ...(["gx01C0401", "gx01C0402", "gx01C0403", "gx01C0404"] as const).map((key, index) => ({
    id: `GX01_C04_0${index + 1}`,
    sceneId: "M1S1",
    order: 40 + index,
    kind: "local_extension" as const,
    title: index === 0 ? "广西学生军｜青年抗日力量" : `广西学生军｜档案 ${index + 1}`,
    bodyZh: frozenText[key],
    required: true,
    provenanceType: "local_extension" as const,
    sourceRefs:
      index === 3 ? ["SRC_GX_STUDENT_ARMY", "SRC_XI_YOUTH_QUOTE"] : ["SRC_GX_STUDENT_ARMY"],
    assetRefs: ["AST-M1S1-PROC-006"],
    pageRefs: [],
    reviewState: "pending_review" as const,
    visibleLabel: "拓展材料",
  })),
  {
    id: "GX05_C08",
    sceneId: "M4S3",
    order: 20,
    kind: "local_extension",
    title: "广西融入⑤｜八路军桂林办事处",
    bodyZh: frozenText.gx05C08,
    required: true,
    provenanceType: "local_extension",
    sourceRefs: ["SRC_GX_WAR_HISTORY", "SRC_GUILIN_CITY_HISTORY"],
    assetRefs: [runtimeStageAssetIdBySceneId.M4S3],
    pageRefs: [],
    reviewState: "pending_review",
    visibleLabel: "拓展材料",
  },
  {
    id: "GX05_C07",
    sceneId: "M3S2",
    order: 20,
    kind: "local_extension",
    title: "广西融入⑤｜地方武装斗争",
    bodyZh: frozenText.gx05C07,
    required: true,
    provenanceType: "local_extension",
    sourceRefs: ["SRC_GX_PARTY_HISTORY_2020"],
    assetRefs: [runtimeStageAssetIdBySceneId.M3S2],
    pageRefs: [],
    reviewState: "pending_review",
    visibleLabel: "拓展材料",
  },
  {
    id: "M4S2_C05",
    sceneId: "M4S2",
    order: 10,
    kind: "lecture",
    title: "大生产、根据地建设与延安精神",
    bodyZh: frozenText.m4s2C05,
    required: true,
    provenanceType: "textbook",
    sourceRefs: ["SRC_TEXTBOOK_CH3"],
    assetRefs: [runtimeStageAssetIdBySceneId.M4S2],
    pageRefs: [{ print: "93—96", pdf: "113—116" }],
    reviewState: "pending_review",
  },
  {
    id: "GX02_C06",
    sceneId: "M4S3",
    order: 30,
    kind: "local_extension",
    title: "广西融入②｜桂林抗战文化运动延续",
    bodyZh: frozenText.gx02C06,
    required: true,
    provenanceType: "local_extension",
    sourceRefs: ["SRC_GX_PARTY_HISTORY_2020", "SRC_GX_WAR_HISTORY"],
    assetRefs: [runtimeStageAssetIdBySceneId.M4S3],
    pageRefs: [],
    reviewState: "pending_review",
    visibleLabel: "拓展材料",
  },
] satisfies ContentBlock[];
